import { render, staticRenderFns } from "./SidebarInformations.vue?vue&type=template&id=16648b46"
import script from "./SidebarInformations.vue?vue&type=script&lang=js"
export * from "./SidebarInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports